import { Component } from '@angular/core'

@Component({
  selector: '[app-modal-header]',
  host: {
    class: 'modal-header',
  },
  template: '<h4 class="modal-title"><ng-content></ng-content></h4>',
  styles: `
    :host {
        display: flex;
        justify-content: center;
        padding-bottom: 0;

        h4 {
          margin-bottom: 0;
        }
    }
  `,
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class ModalHeaderComponent {}
